import api from "src/apis/api";

// Full profile for the signed-in user (account, role/org, RERA, sign-in trail).
export const fetchProfile = () => api.get("/api/v1/profile");

// Users may only update their own name and phone here.
export const updateProfile = ({ name, phone }) =>
  api.patch("/api/v1/profile", { profile: { name, phone } });
